import { useState, useRef, useEffect } from "react";
import Image from "next/image";
import { Col, Row, Container } from "react-bootstrap";
import { customerServices } from "@/services/customerServices";
import { healerServices } from "@/services/healerServices";
import Layout from "@/components/layout";
import Faq from "@/components/faq";
import Testimonial from "@/components/customer/testimonials";
import styles from "@/styles/AboutUs.module.css";
import ExperienceEnergyHealing from "@/components/common/experience-energy-healing";
import Head from "next/head";
import Link from "next/link";

const AboutUs = (props) => {
  const [testimonials, setTestimonial] = useState(props?.testimonials ?? []);
  const [aboutMeta, setAboutMeta] = useState(props?.aboutMeta ?? {});
  const [showSideButton, setShowSideButton] = useState(false);
  const firstSectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!firstSectionRef.current) return;

      const sectionTop = firstSectionRef.current.getBoundingClientRect().bottom;

      setShowSideButton(sectionTop < 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Head>
        <title>{aboutMeta?.meta?.og_title}</title>
        <meta name="title" content={aboutMeta?.meta?.meta_title}></meta>
        <meta
          name="description"
          content={aboutMeta?.meta?.meta_description}
        ></meta>
        <meta name="keywords" content={aboutMeta?.meta?.meta_keywords}></meta>
        <meta property="og:type" content="website"></meta>
        <meta property="og:title" content={aboutMeta?.meta?.og_title}></meta>
        <meta property="og:image" content={aboutMeta?.meta?.og_image}></meta>
        <link rel="canonical" href="https://www.zenkify.com/about-us"></link>
        <meta
          property="og:description"
          content={aboutMeta?.meta?.meta_description}
        ></meta>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={aboutMeta?.meta?.meta_title} />
        <meta
          name="twitter:description"
          content={aboutMeta?.meta?.meta_description}
        />
        <meta name="twitter:image" content={aboutMeta?.meta?.og_image} />
        <meta property="og:url" content="https://www.zenkify.com/about-us" />
        <meta property="og:site_name" content="Zenkify" />
        <meta property="og:image:alt" content="zenkify about us" />
        <meta property="og:image" content={aboutMeta?.meta?.og_image}></meta>
      </Head>
      <section
        ref={firstSectionRef}
        className={`${styles["section-banner"]} ${styles["banner-page"]}`}
        style={{ background: "url(/images/about-banner.jpg)" }}
      >
        <Container>
          <Row>
            <Col md={8} className="m-auto">
              <div className={styles["inner-content"]}>
                <h1 className={styles["banner-title"]}>About Us</h1>
                <p>
                  Welcome to Zenkify. We are dedicated to promoting holistic
                  well-being through energy healing practices. Our platform
                  connects you with certified practitioners and a variety of
                  healing modalities. Join our community and embark on a
                  transformative journey toward physical, emotional, and
                  spiritual balance. Your wellness is our mission.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className={styles["about-section"]}>
        <Container>
          <Row>
            <Col
              lg={7}
              className={
                styles["inner-content"] + " " + "align-self-center pe-lg-5"
              }
            >
              <h3>
                Where the Transformative power of energy healing is accessible
                to all who seek it.
              </h3>
              <p>
                Zenkify is an innovative digital platform designed to provide
                accessible and convenient energy healing services to individuals
                worldwide. This platform utilizes the power of technology to
                connect vast network of skilled energy healers with clients
                remotely and eliminating geographical barriers.The aim is to
                create a revolutionalize platform where the power of in person
                connection and virtual healing unite, charting new Territories
                in Health and Wellness.As pioneers, we have been at the
                forefront of transmuting the way energy healing is accessed and
                experienced.
              </p>
              <p>
                With our deep understanding of the profound impact energy
                healing can have on physical, emotional, and spiritual
                well-being, we have carefully curated a range of services and
                resources that empower you to harness your own healing
                potential. Whether you seek to address specific ailments,
                achieve inner balance, or simply embark on a journey of
                self-discovery, our platform offers a diverse array of
                modalities and techniques to suit your unique needs.
              </p>
            </Col>
            <Col lg={5}>
              <div className={styles["image"]}>
                <Image
                  height={527}
                  width={531}
                  src="/images/about-img.png"
                  alt="Theta Healing Zenkify"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className={styles["about-zenkify"]}>
        <div className="container-fluid">
          <Row>
            <Col lg={4}>
              <div className={styles["image-zenkify"]}>
                <Image
                  height={71}
                  width={300}
                  src="/images/about-zenkify.svg"
                  alt="About Zenkify"
                />
              </div>
            </Col>
            <Col lg={7}>
              <div className={styles["content-inner"]}>
                <h3>About the Name ZENKIFY</h3>
                <p>
                  Zenkify is an amalgamation of 3 powerful words Zen+Ki+Fy. Zen
                  means Peace, Relaxation and Meditation.Ki is the life force
                  energy that animates all living things. And Fy means To
                  Become. The Company name is well curated to define our mission
                  of empowering the World with Healing Energy and treasure the
                  magnificient power inside you.
                </p>
                <p>
                  Through our platform Zenkify, we aim to inspire, educate, and
                  empower individuals to unlock their inner healing potential
                  and embrace a balanced and harmonious life. Our mission is to
                  empower individuals worldwide by providing easy access to
                  transformative energy healing experiences through our online
                  platform. We strive to connect people with highly skilled
                  energy healers, offering a diverse range of modalities, to
                  promote holistic well-being and personal growth.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className={styles["mission-section"]}>
        <Container>
          <Row>
            <Col md={12} className="m-auto">
              <div className="section-title">
                <h3 className="title">Our Mission</h3>
                <p>
                  At Zenkify, our mission is to revolutionize the way people
                  access and experience energy healing. We are dedicated to
                  providing a secure and user-friendly digital space that
                  connects individuals with highly skilled energy healers from
                  around the world. By offering convenient and accessible
                  healing sessions, we aim to empower individuals on their
                  healing journey, promoting physical, emotional, and spiritual
                  well-being. Our mission is to inspire and support personal
                  growth, helping individuals tap into their innate healing
                  abilities and unlock their full potential.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <div className={styles["card-mission"]}>
                <h4>Simplify </h4>
                <p>
                  Access to Healing Energy and Embrace <br /> Inner Harmony
                </p>
              </div>
            </Col>
            <Col md={4}>
              <div className={styles["card-mission"]}>
                <h4>Amplify</h4>
                <p>
                  Healing Energy for a World <br /> of Wellness{" "}
                </p>
              </div>
            </Col>
            <Col md={4}>
              <div className={styles["card-mission"]}>
                <h4>Magnify</h4>
                <p>
                  Healing Connections and Illuminate <br /> Mind Body and Soul
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className={styles["vision-section"]}>
        <Container>
          <Row>
            <Col lg={4} className="align-self-center">
              <div className={styles["image"]}>
                <Image
                  height={348}
                  width={348}
                  src="/images/banner-slider-1.png"
                  alt="Our Vision"
                />
              </div>
            </Col>
            <Col lg={8} className="align-self-center pe-lg-5">
              <div className={styles["content-body"]}>
                <h3>Our Vision</h3>
                <p>
                  Our vision is to create a global network of energy healers and
                  seekers, seamlessly bridging the gap between distance and
                  healing. We envision a world where everyone has access to
                  transformative energy healing experiences, regardless of their
                  geographical location. Through our online platform, we strive
                  to build a vibrant community where individuals can connect,
                  learn, and share their experiences. We aim to be at the
                  forefront of technological advancements, continuously
                  enhancing our platform to provide innovative features, such as
                  interactive workshops, educational resources, and virtual
                  healing circles. Our ultimate vision is to create a ripple
                  effect of healing and positive energy, fostering personal
                  empowerment, holistic well-being, and spiritual awakening on a
                  global scale.
                </p>
                <p>
                  Our platform combines cutting-edge technology, advanced
                  healing practices, and a vast network of skilled practitioners
                  to provide a comprehensive and transformative healing journey
                  for individuals like you.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className={styles["benefits-registering"]}>
        <Container>
          <Row>
            <div className={styles["flower-top"]}>
              <Image
                height={130}
                width={130}
                src="/images/goldern-flower-icon.svg"
                alt="flower"
              />
            </div>
            <Col md={5} className="order-md-2">
              <div className={styles["rightimage-benefits"]}>
                <Image
                  height={306}
                  width={400}
                  src="/images/benefits-registering.svg"
                  alt="benefit-registering"
                />
              </div>
            </Col>
            <Col md={7}>
              <div className={styles["content-inner"]}>
                <h3>Benefits of Registering with Us</h3>
                <ul>
                  <li>
                    <h4>Accessibility:</h4>
                    <p>
                      Users can access energy healing services regardless of
                      their location, allowing them to connect with healers from
                      around the world.
                    </p>
                  </li>
                  <li>
                    <h4>Convenience:</h4>
                    <p>
                      Sessions can be scheduled at a time that suits the client,
                      making it easier to fit healing into busy schedules. You
                      can opt for audio, video and in-person sessions, the
                      choice is yours.
                    </p>
                  </li>
                  <li>
                    <h4>Variety of healers and modalities:</h4>
                    <p>
                      The platform often hosts a diverse range of healers, each
                      with their unique expertise, enabling clients to find a
                      healer and modality that resonates with them.
                    </p>
                  </li>
                  <li>
                    <h4>Learn Various Energy Healing Course:</h4>
                    <p>
                      Zenkify provides you the platform to enroll for the
                      different energy healing course which provides an
                      opportunity to expand your knowledge, enhance your skills,
                      and deepen your understanding of energy healing.
                    </p>
                  </li>
                  <li>
                    <h4>Simplified Usage:</h4>
                    <p>
                      {" "}
                      It operates through a website, where users can create
                      accounts and browse through a directory of verified and
                      well experienced energy healers.
                    </p>
                  </li>
                  <li>
                    <h4>Verified and Validated:</h4>
                    <p>
                      The healers specialize in various modalities such as
                      Reiki, Theta Healing, and more. Each healer&apos;s profile
                      includes information about their background, experience,
                      and the specific services they offer. Each Healer has to
                      undergo a thorough verifying process before getting
                      registered on the platform.
                    </p>
                  </li>
                  <li>
                    <h4>Secure Payment Processing:</h4>
                    <p>
                      {" "}
                      Zenkify ensures that clients can conveniently handle
                      transactions and book sessions with ease.
                    </p>
                  </li>
                  <li>
                    <h4>Embrace Feedback:</h4>
                    <p>
                      {" "}
                      At Zenkify we also offer features such as ratings and
                      reviews, allowing users to provide feedback and help
                      others in choosing the right healer for their needs.
                    </p>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className={styles["verifying-process"]}>
        <div className={styles["flower-top-left"]}>
          <Image
            height={130}
            width={130}
            src="/images/goldern-flower-icon.svg"
            alt="flower"
          />
        </div>
        <div className={styles["flower-top-right"]}>
          <Image
            height={100}
            width={100}
            src="/images/flower-2.svg"
            alt="flower"
          />
        </div>
        <Container>
          <Row>
            <Col md={8} className="m-auto">
              <div className="section-title">
                <h3 className="title">
                  Verifying Process we follow at Zenkify
                </h3>
                <p>
                  The validating and verifying process for energy healers on
                  Zenkify typically involves a comprehensive evaluation to
                  ensure the quality, authenticity, and professionalism of the
                  healers.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <div className={styles["verifying-leftimage"]}>
                <Image
                  width={300}
                  height={298}
                  src="/images/verifying-leftimage.svg"
                  alt="verifying process"
                />
              </div>
            </Col>
            <Col md={8}>
              <div className={styles["content-inner"]}>
                <ul>
                  <li>
                    <h4>Application and Documentation:</h4>
                    <p>
                      Healers interested in joining the platform are typically
                      required to submit an application providing their
                      professional background, qualifications, certifications,
                      and relevant experience. This documentation helps assess
                      the healer&apos;s expertise and credibility.
                    </p>
                  </li>
                  <li>
                    <h4>Review of Credentials: </h4>
                    <p>
                      The Zenkify administrators or a dedicated team carefully
                      review the submitted credentials and documentation,
                      verifying the healer&apos;s qualifications,
                      certifications, and any relevant licenses. This step
                      ensures that the healers meet the necessary standards and
                      requirements.
                    </p>
                  </li>
                  <li>
                    <h4>Assessment of Experience:</h4>
                    <p>
                      The healer&apos;s experience and practical knowledge are
                      assessed to gauge their proficiency in different energy
                      healing modalities. This evaluation may involve reviewing
                      case studies, client testimonials, or conducting
                      interviews to understand the healer&apos;s approach and
                      expertise.
                    </p>
                  </li>
                  <li>
                    <h4>Ethics and Professionalism:</h4>
                    <p>
                      We ensures that healers maintain professional conduct,
                      uphold ethical standards, and prioritize client well-being
                      and confidentiality.
                    </p>
                  </li>
                  <li>
                    <h4>Evaluation of Modalities and Specializations:</h4>
                    <p>
                      We assesses the healer&apos;s modalities and
                      specializations to ensure a diverse range of offerings for
                      clients. This evaluation ensures that the healers possess
                      the necessary skills and knowledge in their specific area
                      of expertise.
                    </p>
                  </li>
                  <li>
                    <h4>Interview or Demo Session:</h4>
                    <p>
                      We conduct interviews or request healers to provide a demo
                      session to evaluate their communication skills,
                      professionalism, and ability to deliver effective healing
                      experiences remotely. This step helps assess the
                      healer&apos;s interpersonal skills and ensures a positive
                      client-healer interaction.
                    </p>
                  </li>
                  <li>
                    <h4>Ongoing Review and Quality Control:</h4>
                    <p>
                      Once accepted, healers are often subject to ongoing review
                      and quality control measures to ensure consistent
                      standards of service. Feedback from clients, ratings, and
                      reviews may be considered to maintain the quality and
                      effectiveness of the healers on the platform.
                    </p>
                  </li>
                  <li>
                    <h4>By implementing a thorough vetting process:</h4>
                    <p>
                      Zenkify aim to connect clients with qualified and
                      reputable healers, enhancing the overall user experience
                      and ensuring the delivery of trusted energy healing
                      services.
                    </p>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <ExperienceEnergyHealing />
      <Faq />
      <Testimonial props={{ testimonials }} />
      <Link
        id="floatingBook"
        className="floating-book"
        aria-label="Book a FREE call now"
        href="/healers"
        style={{ opacity: showSideButton ? 1 : 0 }}
      >
        Book a FREE call now
      </Link>
    </>
  );
};

export default AboutUs;

AboutUs.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};

// ssr
export async function getServerSideProps() {
  const fetchTestimonials = async () => {
    const res = await customerServices.getTestimonials();
    if (res.status) {
      return res.data;
    } else {
      toast.error(res.message, {
        autoClose: 5000,
      });
    }
  };
  const fetchAboutMeta = async () => {
    try {
      const res = await healerServices.getMetaInformation("about-us");
      if (res.status) {
        return res.data;
      }
    } catch (error) {
      console.error("Error fetching slider data:", error);
    }
  };

  const testimonials = (await fetchTestimonials()) ?? {};
  const aboutMeta = (await fetchAboutMeta()) ?? {};

  // Pass data to the page via props
  return { props: { testimonials, aboutMeta } };
}
